import { observer } from "mobx-react-lite";

import { ParameterProps } from "./types";
import { ParameterGroup } from "./ParameterGroup";
import { BasicParameter } from "./BasicParameter";
import { COMMON_STYLES } from "./constants";

import { ComponentType } from "@/queries/models/types";

export const Parameter = observer(
  ({ parameter, readOnly, shouldShowToggle, isDisabled, isPreview, onUpdate }: ParameterProps) => {
    const { labelClasses, disabledClass } = COMMON_STYLES;

    if (parameter.componentType === ComponentType.GROUP) {
      return (
        <ParameterGroup
          disabledClass={disabledClass}
          shouldShowToggle={shouldShowToggle}
          labelClasses={labelClasses}
          parameter={parameter}
          readOnly={readOnly}
          isPreview={isPreview}
          isDisabled={parameter.isDisabled || isDisabled}
          onUpdate={onUpdate}
        />
      );
    }

    return (
      <BasicParameter
        parameter={parameter}
        shouldShowToggle={shouldShowToggle}
        labelClasses={labelClasses}
        disabledClass={disabledClass}
        isDisabled={parameter.isDisabled || isDisabled}
        readOnly={readOnly}
        isPreview={isPreview}
        onUpdate={onUpdate}
      />
    );
  },
);
